import {useTranslation} from "react-i18next";
import NavBreadcrum from "components/NavBreadcrum";
import navs from "./navs";


const Configuration = () => {

    const [t] = useTranslation("routes")
    const bread = [
        {name: t("labels.alerts"), url: "/alerts/", current: false},
        {name: t("labels.configuration"), current: true}
    ]





    return (
        <>
            <NavBreadcrum navs={navs} bread={bread}/>
            <h1>Pendiente de quitar</h1>
        </>
    )
}
export default Configuration;